import * as React from 'react';

function Error(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.245 18.038H5.755a1 1 0 01-.86-1.51L11.14 5.99a1 1 0 011.72 0l6.245 10.539a1 1 0 01-.86 1.51zm-6.958-8.75a.714.714 0 111.425 0l-.187 3.751a.526.526 0 01-1.05 0l-.188-3.751zm.713 6.75c.425 0 .75-.324.75-.75 0-.312-.25-.75-.75-.75a.744.744 0 00-.75.75c0 .426.338.75.75.75z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Error;
